// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"d014e0ea","322":"f22d5b8b","424":"a981284c"}[chunkId] + ".chunk.css";
};